<template>
    <div class="apply-result">
        <div class="result-body">
            <img v-if="type != 'failed'" :src="checkIco" alt="" class="result-ico">
            <div :class="['result-title',{rejected:type === 'failed'}]">{{ checkTitle }}</div>
            <div class="check-desc">
                <template v-if="type != 'failed'">
                    <p>
                        信息提交成功！我们将在1-3个工作日内审核完成,请耐心等待
                    </p>
                    <p>审核结果,我们将通过短信通知您。
                        <template v-if="type === 'checking'"><span>如有疑问可点击咨询</span>
                        <span 
                            class="service-link"
                            @click="onService"
                        >
                            在线客服
                        </span>
                    </template>
                    </p>
                </template>
                <template v-else>
                    <p>
                        申请未通过，请重新提交
                    </p>
                    <p>
                        拒绝原因：{{reason}}
                    </p>
                </template>
            </div>
            <div v-if="type != 'failed'" class="return-btn" @click="$router.replace({name:'Index'})">返回首页</div>
            <div v-else class="return-btn" @click="onApply">重新申请</div>
        </div>
        <chat ref="chat"></chat>
    </div>
</template>
<script>
import { patternMakerInfo } from '@/api/index';
import { mapState } from 'vuex';
export default{
    data(){
        return{
            type:'',
            reason:''
        }
    },
    computed:{
        ...mapState({
            userInfo:state=>state.userInfo
        }),
        checkIco(){
            const {type} = this;
            switch(type){
                default:
                    return require('@/assets/images/patternMaker/icon-apply-success.png');
                case 'checking':
                    return require('@/assets/images/patternMaker/icon-apply-checking.png');
            }
        },
        checkTitle(){
            const {type} = this;
            switch(type){
                default:
                    return '版师入驻申请信息提交成功!';
                case 'checking':
                    return '审核中...';
                case 'failed':
                    return '已拒绝';
            }
        },
    },
    mounted(){
        console.log('aaa',this.$route.params);
        const {type} = this.$route.query;
        if(!type || !['checking','apply'].includes(type)){
            this.$layer.msg('类型未定义');
            this.$router.back();
            return;
        }
        console.log('type',type);
        // if(!type) this.$router.back();
        // this.type = type;
        this.getCheckInfo();
    },
    methods:{
        async onApply(){
            if(!this.userInfo.id){
                this.$layer.msg('请先注册成为平台用户或登录再操作');
                this.$router.push({name:"Login",query:{back_name:'PMRegister',type:'wechat'}});
                return;
            }
            const check = await this.getCheckInfo();
            if(!check){
                this.$router.push({
                    name:"PMRegisterForm",query:{reApply:true}
                })
            }
        },
        async getCheckInfo(){
            try{
                const {code,data} = await patternMakerInfo();
                console.log('data',data);
                this.status = data.status;
                if(code>0){
                    this.status = -1;
                    return false;
                }
                if(data.status && data.status == 1){
                    console.log('apply-status',data.status)
                    // this.$layer.msg('申请已通过');
                    this.type = 'passed';
                }
                if(data.status && data.status == 2){
                    console.log('apply-status',data.status)
                    // this.$layer.msg('申请未通过');
                    this.reason = data.reason;
                    this.type = 'failed';
                }
                if(data.status && data.status == 0){
                    this.type = 'checking';
                }
                
            }catch(e){
                console.log('err',e);
            }
        },
        onService(){
             this.$refs["chat"].showChat();
        },
    }
}
</script>
<style lang="scss" scoped>
.apply-result{
    width:100%;
    min-height:100vh;
    background:#f5f9fc;
    display:flex;
    justify-content:center;
    .result-body{
        width:100%;
        max-width:1000px;
        height:776px;
        background:#fff;
        border-radius:10px;
        box-shadow:0px 0px 8px 4px rgba(1,32,55,0.05);
        margin-top:28px;
        display:flex;
        flex-direction:column;
        align-items:center;
        .result-ico{
            width:182px;
            height:98px;
            margin-top:108px;
        }
        .result-title{
            font-weight:bold;
            font-size:26px;
            color:#02c160;
            margin-top:47px;
            &.rejected{
                color:red;
                margin-top:20%;
            }
        }
        .check-desc{
            color:#666;
            font-size:14px;
            text-align:center;
            margin-top:16px;
            .service-link{
                cursor:pointer;
                color:#0d99ff;
            }
        }
        .return-btn{
            width:120px;
            height:40px;
            text-align:center;
            line-height:40px;
            border-radius:4px;
            border:1px solid #e3e3e3;
            cursor:pointer;
            color:#333;
            font-size:14px;
            margin-top:76px;
        }
    }
}
</style>